import { useDataChange } from 'Simple/Data.js'

export function useOnChangeActionType(props) {
  let change = useDataChange({
    context: 'event_action',
    viewPath: props.viewPath,
  })
  let changeExpanded = useDataChange({
    context: 'expand',
    path: 'is_expanded',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    change(next => {
      next.type = value
      next.data = getActionData(value)
    })
    changeExpanded(true)
  }
}

function getActionData(action_type) {
  switch (action_type) {
    case 'task_insert':
      return {
        title: null,
        description: null,
        task_basket_id: null,
        document_template_id: null,
      }
    case 'task_insert_new':
      return {
        title: null,
        description: null,
        board_id: null,
        stage_id: null,
        actions: [],
        tags: [],
      }
    case 'status_update':
      return {
        is_subset: false,
        subset_statuses: [],
        has_default_status: false,
        default_status: null,
      }
    case 'send_communication':
      return {
        email: true,
        sms: true,
        email_template: {
          advanced_editor: false,
          content: '',
          enabled: true,
        },
        sms_template: {
          content: '',
          enabled: true,
        },
      }
    case 'http':
      return {
        req: {
          url: '',
          method: 'get',
          headers: {
            'Content-Type': 'application/json',
          },
          body: null,
        },
      }
    case 'check_requirements':
      return {
        requirements: [],
      }
    case 'wait': {
      return {
        weeks: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        type: 'after',
        event: 'automation_triggered',
      }
    }
    case 'create_procedure_receivables':
      return {
        is_skippable: false,
        create_task: false,
        task_title: null,
        task_description: null,
      }
    case 'task_update':
      return {
        board_id: null,
        stage_id: null,
        due_in_days: null,
        tags: [],
        assignee_id: null,
        priority: null,
        comment: null,
      }
    default:
      return null
  }
}
